module.exports = __webpack_public_path__ + "img/capa-padrao-direito.592aff57.png";